import CourtType from "../enums/court-type";
import TiebreakType from "../enums/tiebreak-type";
import GameType from "../enums/game-type";
import ScoringMode from "../enums/scoring-mode";

const commonFormData = {
    numberOfMatches: {
        title: "Number Of Matches",
        order: 1,
        min: 0,
        max: 100
    },
    gameType: {
        title: "Game Type",
        order: 2,
        options: Object.values(GameType)
    },
    gamesPerSet: {
        title: "Games Per Set",
        order: 3,
        min: 1,
        max: 13
    },
    tieBreakType: {
        title: "Set Tiebreak Points",
        order: 4,
        options: Object.values(TiebreakType)
    },
    scoringMode: {
        title: "Scoring Mode",
        order: 5,
        options: Object.values(ScoringMode)
    },
    courtType: {
        title: "Court Type",
        order: 6,
        options: Object.values(CourtType)
    }
};

const customFormData = {
    singles: commonFormData,
    doubles: commonFormData
};

export default customFormData;
